module.exports = Backbone.Model.extend({
    load(bookingData = {}) {
        this.set({bookingData});
    },

    getBookingData() {
        return this.get('bookingData') || {};
    },

    getBookingId() {
        const {bookingBasicInfo = {}} = this.getBookingData();
        return bookingBasicInfo.id;
    },

    getBookingNumOfFlights() {
        return this.getBookingData().totalPnrsInBooking || -1;
    },

    getRefundStatusData() {
        return {
            accommodationBooking: this.getBookingData().accommodationBooking,
            myTripStatus: this.getBookingData().myTripStatus,
            totalPnrsInBooking: this.getBookingData().totalPnrsInBooking,
            bookingId: this.getBookingId(),
            numOfFlights: this.getBookingNumOfFlights(),
        };
    },
});
